export default __webpack_public_path__ + "static/media/member-id.3d58f517.svg";